import { useGetApplicationPlatformsDictionary } from '@api/hooks/dictionaries';

export function useApplicationPlatforms() {
  return useGetApplicationPlatformsDictionary();
}
